module.exports = __webpack_public_path__ + "img/manage_user.eaa2c613.svg";